import { addListener, createListenerMiddleware } from '@reduxjs/toolkit';
import is from '@sindresorhus/is';
import { ErrorMonitoring } from '@ui/services/error-monitoring';
import type { AppDispatch, RootState } from '@ui/store';

export const listenerMiddleware = createListenerMiddleware({
  onError: (e, listenerApi) => {
    let error = new Error('Error in store listener middleware');

    if (is.string(e)) {
      error = new Error(e);
    } else if (is.error(e)) {
      error = e;
    }

    ErrorMonitoring.captureException(error, {
      tags: {
        raisedBy: listenerApi.raisedBy,
      },
    });
  },
});

/**
 * Starts listening to actions (outside of components).
 *
 * @allowUnusedExport
 */
export const startListening = listenerMiddleware.startListening.withTypes<
  RootState,
  AppDispatch
>;

export const addAppListener = addListener.withTypes<RootState, AppDispatch>();
